import * as z from 'zod';

var Generate;
(function (Generate) {
    (function (Request) {
        Request.schema = z.object({
            payload: z.record(z.string(), z.unknown()),
        });
    })(Generate.Request || (Generate.Request = {}));
    (function (Response) {
        Response.schema = z.object({
            bullets: z.array(z.object({ html: z.string() })).nullable(),
        });
    })(Generate.Response || (Generate.Response = {}));
})(Generate || (Generate = {}));

export { Generate };
